import { render, staticRenderFns } from "./bigTooltip.vue?vue&type=template&id=4f27b52e&scoped=true"
import script from "./bigTooltip.vue?vue&type=script&lang=js"
export * from "./bigTooltip.vue?vue&type=script&lang=js"
import style0 from "./bigTooltip.vue?vue&type=style&index=0&id=4f27b52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f27b52e",
  null
  
)

export default component.exports